import { useRouter } from 'next/router';
import { mediaQuery, Spacings } from '@styles/index';
import useClassInfo from '@api/hooks/class/useClassInfo';
import useCourseInfo from '@api/hooks/course/useCourseInfo';
import styled from '@emotion/styled';
import Divider from 'aquilla/core/atoms/Divider';
import Dynamic from '@base/Dynamic/Dynamic';
import { CLASS_SIGNUP_BANNER } from '@comp/SignupGenericBanner/constant';
import { useEffect } from 'react';
import usePlayerStore from '@cont/ClassVideoPlayer/hooks/usePlayerStore';
import HeaderSkeleton from './Skeleton/Header';
import useLanding from './useLanding';
import SimilarCourses from './SimilarCourses';
import Header from './Header';

const SignupGenericBanner = Dynamic(() =>
  import('@comp/SignupGenericBanner/SignupGenericBanner')
);

const SimilarCoursesTest = Dynamic(() => import('./SimilarCoursesTest'));

const Container = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1 / -1;
`;

const HeaderContainer = styled.div``;

const ClassContainer = styled.div`
  display: none;
  ${mediaQuery.uptoMobile} {
    display: block;
  }
`;

const StyledDivider = styled(Divider)`
  width: 100%;
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_4B};
    box-sizing: border-box;
  }
`;

const StyledSignupBanner = styled(SignupGenericBanner)`
  margin-top: ${Spacings.SPACING_10B};

  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_6B};
  }
`;

const ClassPage = () => {
  const {
    query: { uid: classUID }
  } = useRouter();
  const { classInfo } = useClassInfo(classUID);
  const { setIsClassPage } = usePlayerStore();
  const { course: courseInfo } = useCourseInfo(classInfo.programme.uid);

  useLanding();
  useEffect(() => {
    setIsClassPage(true);
  }, [setIsClassPage]);

  if (!classInfo.uid || !courseInfo.uid) {
    return typeof window === 'undefined' ? null : <HeaderSkeleton />;
  }

  return (
    <>
      <Container>
        <HeaderContainer>
          <Header />
        </HeaderContainer>
        <StyledDivider />
        <StyledSignupBanner
          data={CLASS_SIGNUP_BANNER}
          goalUID={courseInfo.goal.uid}
        />
        <SimilarCoursesTest goal={courseInfo?.goal} />
        <ClassContainer>
          <SimilarCourses />
        </ClassContainer>
      </Container>
    </>
  );
};

export default ClassPage;
